import { generateHash } from "@/utils";
import { API_ROUTES } from "@/config";
import { mapActions } from "vuex";
import alertMessageMixin from "./alertMessageMixin";

export default {
  mixins: [alertMessageMixin],
  data() {
    return {
      img: null,
      selected: null,
      errors: [],
      messageEmailPhone: null,
      isValidatePassword: false,
      messageValidatePassword: "",
    };
  },
  methods: {
    ...mapActions("user", ["loadAuthenticated"]),
    async saveData() {
      const me = this;
      try {
        me.isBusy = true;
        const dataAdicional = await generateHash();
        me.formData.identy_document = me.formData.identy_document + "";
        await me.repository.register({
          ...me.formData,
          ...dataAdicional,
          dev0: process.env.VUE_APP_DEBUG_CUSTOM,
        });
        // me.$router.push("/registro-exitoso");
      } catch (error) {
        const code = error.response.status;
        me.messageEmailPhone = null;
        me.errors = [];

        const data = error.response.data;
        if (data.msg) {
          me.messageEmailPhone = data;
          Object.values(data.msg).forEach((el) => {
            me.errors.push({ name: el[0] });
          });
        }

        if (code == 423) {
          const { message } = error.response.data;
          me.alertMenssage(message, 3000);
          me.$router.push({
            name: "VerifyCellPhone",
            query: { telephone: me.formData.telephone },
          });
        }
      } finally {
        me.isBusy = false;
      }
    },
    async loadCodeArea() {
      const me = this;
      try {
        const dataAdicional = await generateHash();
        const { data } = await me.repository.getAll(dataAdicional);

        data.data.forEach((el) => {
          el.phone_code = `+${el.phone_code}`;
          el.path_img_iso_medium = `${API_ROUTES.image.get}${el.path_img_iso_medium}`;
          el.path_img_iso_large = `${API_ROUTES.image.get}${el.path_img_iso_large}`;
        });
        me.codes = data.data;
        me.formData.code_area_id = 44;
        me.selected = 44;
        me.loadImg(me.formData.code_area_id);
      } catch (error) {
        // console.log(error);
      }
    },
    selectedCode() {
      const me = this;
      me.formData.code_area_id = me.selected;
      me.loadImg(me.formData.code_area_id);
    },
    loadImg(id) {
      const me = this;
      const code = me.codes.find((el) => el.id == id);
      me.img = code.path_img_iso_large;
    },
    validatePassword() {
      const me = this;
      me.isValidatePassword = true;
      // Verificar que la contraseña tenga al menos 8 caracteres
      if (me.formData.password.length < 8) {
        me.messageValidatePassword =
          "La contraseña debe tener al menos 8 carácteres.";
        return;
      }

      // Verificar que la contraseña contenga al menos una letra mayúscula
      if (!/[A-Z]/.test(me.formData.password)) {
        me.messageValidatePassword =
          "La contraseña debe contener al menos una letra mayúscula.";
        return;
      }

      // Verificar que la contraseña contenga al menos una letra minúscula
      if (!/[a-z]/.test(me.formData.password)) {
        me.messageValidatePassword =
          "La contraseña debe contener al menos una letra minúscula.";
        return;
      }

      // Verificar que la contraseña contenga al menos un número
      if (!/[0-9]/.test(me.formData.password)) {
        me.messageValidatePassword =
          "La contraseña debe contener al menos un número.";
        return;
      }

      // Verificar que la contraseña contenga al menos un carácter especial
      if (!/[^A-Za-z0-9]/.test(me.formData.password)) {
        me.messageValidatePassword =
          "La contraseña debe contener al menos un carácter especial.";
        return;
      }

      // Si la contraseña pasa todas las validaciones, es válida
      me.isValidatePassword = false;
    },
  },
};
